import type { AICommandDTO } from '@next-space/fe-api-idl';
import { useEffect } from 'react';
import { request } from 'src/common/request';
import { setAppUiState } from 'src/services/app';
import { useEnableAI } from '../block/use-enable-AI';
import { useCurrentSpace } from '../space';

export const useFetchAICommand = () => {
  const { enableAI } = useEnableAI();
  useEffect(() => {
    if (!enableAI) return;
    void request.ai.getAiConfig().then((res) => {
      setAppUiState({ $aiCommands: res });
      const record: Record<string, AICommandDTO> = {};
      res.forEach((r) => {
        record[r.uuid] = r;
      });
    });
  }, [enableAI]);
};

export const useFetchAiConfig = () => {
  useFetchAICommand();
  // NOTE 团队空间不需要允许成员才能使用，都可以用
  // const currentSpace = useCurrentSpace();

  // useEffect(() => {
  //   // 检测空间成员是否有AI权限
  //   void request.infra.getSpaceAiMembers(currentSpace.uuid).then((data) => {
  //     setAppUiState({ $aiMembers: data });
  //   });
  // }, [currentSpace.uuid]);
};
